'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
 * Extends jQuery with helper functions.
 */
$.fn.extend({

	/**
  * Check if element has an attribute, like $(...).hasClass('foo');
  * '[' and ']' will be removed first.
  *
  * @param {string} selector attribute name including […], e.g. '[data-sample]'
  * @returns {boolean} if jQuery query has atrribute
  */
	// eslint-disable-next-line object-shorthand
	hasAttr: function hasAttr(selector) {
		var $elem = $(this);

		// Remove '[' and ']'
		selector = selector.replace('[', '').replace(']', '');

		// Get attribute
		var attr = $elem.attr(selector);

		// true if attribute defined. For some browsers, `attr` is undefined; for others, `attr` is false. Check for both.
		return (typeof attr === 'undefined' ? 'undefined' : _typeof(attr)) !== (typeof undefined === 'undefined' ? 'undefined' : _typeof(undefined)) && attr !== false;
	},

	/**
  * Check if script with provided src is already in dom
  * If the script is not in dom, loading starts and callback event is attached
  *
  * @param {string} src The Source of the script to load
  * @param {Function} callbackMethod The callback method to run
  */
	// eslint-disable-next-line object-shorthand
	loadScript: function loadScript(src, callbackMethod) {
		var script = void 0;
		var $script = $('script[src="' + src + '"]');

		if (!$script.length) {
			script = document.createElement('script');

			if (typeof callbackMethod === 'function') {
				script.onload = function () {
					return callbackMethod();
				};
			}

			document.body.appendChild(script);
			script.src = src;
			return script.src;
			// eslint-disable-next-line no-else-return
		} else if (typeof callbackMethod === 'function') {
			return callbackMethod();
		}
	},

	/**
  * Check if css with provided href is already in dom
  * If the css is not in dom, loading starts and callback event is attached
  *
  * @param {string} href The link of the css to load
  * @param {Function} callbackMethod The callback method to run
  */
	// eslint-disable-next-line object-shorthand
	loadStyles: function loadStyles(href, callbackMethod) {
		var styles = void 0;
		var $styles = $('link[href="' + href + '"]');

		if (!$styles.length) {
			styles = document.createElement('link');
			styles.media = 'all';
			styles.rel = 'stylesheet';
			styles.href = href;

			if (typeof callbackMethod === 'function') {
				styles.onload = function () {
					return callbackMethod();
				};
			}

			document.head.insertBefore(styles, document.head.childNodes[document.head.childNodes.length - 1].nextSibling);
			return styles.href;
			// eslint-disable-next-line no-else-return
		} else if (typeof callbackMethod === 'function') {
			return callbackMethod();
		}
	}
});